export default function handleProgressForm(data) {
  const fieldHide = "*";
  const fields = [
    // data.frequenciaCardiaca,
    // data.pressaoArterial,
    // data.pesoAtual === "000000" ? "" : data.pesoAtual,
    // data.perdaDePeso,
    // data.fluenciaVerbal,
    // data.rastreioComportamental,
    // data.apatia,
    // data.statusCognitivo,
    data.reflexoFotomotor,
    data.papilederma,
    data.motricidadeOcular,
    data.ptosePalpebral,
    data.reflexoNauseoso,
    data.musculaturaFacial[data.musculaturaFacial.length - 1],
    data.masseter,
    data.linguaAtrofia,
    data.linguaMovimentacao,
    data.linguaFasciculacao,
    data.veloPalatino,
    data.disartria,
    data.anartria,
    data.abducaoCoxasDireita,
    data.abducaoCoxasEsquerda,
    data.flexaoQuadrisDireita,
    data.flexaoQuadrisEsquerda,
    data.extensaoJoelhosDireita,
    data.extensaoJoelhosEsquerda,
    data.flexaoJoelhosDireita,
    data.flexaoJoelhosEsquerda,
    data.dorsiflexaoJoelhosDireita,
    data.dorsiflexaoJoelhosEsquerda,
    data.inversaoPesDireita,
    data.inversaoPesEsquerda,
    data.flexaoPlanarPesDireita,
    data.flexaoPlanarPesEsquerda,
    data.abducaoOmbrosDireita,
    data.abducaoOmbrosEsquerda,
    data.flexaoCotovelosDireita,
    data.flexaoCotovelosEsquerda,
    data.extensaoCotovelosDireita,
    data.extensaoCotovelosEsquerda,
    data.flexaoPunhosDireita,
    data.flexaoPunhosEsquerda,
    data.extensaoDedosDireita,
    data.extensaoDedosEsquerda,
    data.abducaoDedosDireita,
    data.abducaoDedosEsquerda,
    data.abducaoPolegarDireita,
    data.abducaoPolegarEsquerda,
    data.primeiroInterosseoDorsalDireita,
    data.primeiroInterosseoDorsalEsquerda,
    data.MIDProximal,
    data.MIDDistal,
    data.MIEProximal,
    data.MIEDistal,
    data.MSDProximal,
    data.MSDDistal,
    data.MSEProximal,
    data.MSEDistal,
    data.fasciculacoesMotor,
    data.fasciculacoesMotor === "50"
      ? data.fasciculacoesMotorOnde[data.fasciculacoesMotorOnde.length - 1] ??
        ""
      : fieldHide,
    data.MSD,
    data.MSE,
    data.MID,
    data.MIE,
    data.reflexoBicipitalDireita,
    data.reflexoBicipitalEsquerda,
    data.reflexoTricipitalDireita,
    data.reflexoTricipitalEsquerda,
    data.reflexoPatelarDireita,
    data.reflexoPatelarEsquerda,
    data.reflexoAquileuDireita,
    data.reflexoAquileuEsquerda,
    data.reflexoCutaneoDireita,
    data.reflexoCutaneoEsquerda,
    data.sinalDeHoffmannDireita,
    data.sinalDeHoffmannEsquerda,
    data.tremor,
    data.ataxia,
    data.bradicinesia,
    data.parestesias,
    data.disestesias,
    data.alodinia,
    data.MIDProximalVibratoria,
    data.MIDProximalTactil,
    data.MIDProximalDor,
    data.MIDDistalVibratoria,
    data.MIDDistalCinetPost,
    data.MIDDistalTactil,
    data.MIDDistalDor,
    data.MIEProximalVibratoria,
    data.MIEProximalCinetPost,
    data.MIEProximalTactil,
    data.MIEProximalDor,
    data.MIEDistalVibratoria,
    data.MIEDistalCinetPost,
    data.MIEDistalTactil,
    data.MIEDistalDor,
    data.MSDProximalVibratoria,
    data.MSDProximalCinetPost,
    data.MSDProximalTactil,
    data.MSDProximalDor,
    data.MSDDistalVibratoria,
    data.MSDDistalCinetPost,
    data.MSDDistalTactil,
    data.MSDDistalDor,
    data.MSEProximalVibratoria,
    data.MSEProximalCinetPost,
    data.MSEProximalTactil,
    data.MSEProximalDor,
    data.MSEDistalVibratoria,
    data.MSEDistalCinetPost,
    data.MSEDistalTactil,
    data.MSEDistalDor,
    data.disfuncaoAutonomica,
    data.disfuncaoAutonomica === "50"
      ? data.tipoDisfuncao[data.tipoDisfuncao.length - 1] ?? ""
      : fieldHide,
  ];
  if (fields.every((campo) => campo !== "")) {
    return "full";
  } else if (fields.some((campo) => campo !== "" && campo !== fieldHide)) {
    return "partial";
  } else {
    return "empty";
  }
}
